import { Provider } from '@angular/core';

import { DialogService } from './dialog.service';

export function provideDialog(): Provider[] {
  return [DialogService];
}
